import { useEffect, useCallback, useRef } from 'react';
import { getUserStorageKey, setUserData, getUserData, removeUserData } from '../utils/userStorage';

// Debounce 함수
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
};

export const useAutoSave = (data, key = 'editor_state', delay = 1000) => {
  const saveTimeoutRef = useRef(null);
  
  // 사용자별 localStorage에 저장하는 함수
  const saveToStorage = useCallback((dataToSave) => {
    try {
      const success = setUserData(key, dataToSave);
      if (success) {
        console.log(`Editor state auto-saved for user: ${getUserStorageKey(key)}`);
      }
    } catch (error) {
      console.warn('Failed to save editor state:', error);
    }
  }, [key]);

  // Debounced 저장 함수
  const debouncedSave = useCallback(
    debounce(saveToStorage, delay),
    [saveToStorage, delay]
  );

  // 데이터 변경 시 자동 저장
  useEffect(() => {
    if (data) {
      debouncedSave(data);
    }
  }, [data, debouncedSave]);

  // 사용자별 localStorage에서 복원하는 함수
  const restoreFromStorage = useCallback(() => {
    try {
      const saved = getUserData(key, null);
      console.log(`Editor state restored for user: ${getUserStorageKey(key)}`);
      return saved;
    } catch (error) {
      console.warn('Failed to restore editor state:', error);
      return null;
    }
  }, [key]);

  // 사용자별 저장된 데이터 삭제
  const clearSavedData = useCallback(() => {
    const success = removeUserData(key);
    if (success) {
      console.log(`Editor state cleared for user: ${getUserStorageKey(key)}`);
    }
  }, [key]);

  return {
    restoreFromStorage,
    clearSavedData,
    saveToStorage: saveToStorage // 즉시 저장용
  };
};

export default useAutoSave;